/*
 * Keep Textbox by Textify line-item properties in Dawn's AJAX add-to-cart flow.
 * Scope: every product form using Textbox by Textify.
 */
(() => {
  const enableStandardProductForm =
    document.currentScript?.dataset.standardProductForm === 'true';

  const isDisplayed = (element) => {
    if (element.hidden) return false;

    for (
      let current = element;
      current && current !== document.body;
      current = current.parentElement
    ) {
      const style = window.getComputedStyle(current);
      if (style.display === 'none' || style.visibility === 'hidden') {
        return false;
      }
    }

    if (typeof element.getClientRects !== 'function') return true;

    return Boolean(
      element.offsetWidth ||
        element.offsetHeight ||
        element.getClientRects().length
    );
  };

  const getTextifyFields = (form, displayedOnly = true) => {
    const productId = form.querySelector('[name="product-id"]')?.value;
    const roots = Array.from(
      document.querySelectorAll('#textfieldapp[data-tb-product-id]')
    ).filter(
      (root) => !productId || root.dataset.tbProductId === String(productId)
    );

    return roots.flatMap((root) =>
      Array.from(root.querySelectorAll('[data-tb-app-fields="true"]')).filter(
        (field) =>
          !field.disabled && (!displayedOnly || isDisplayed(field))
      )
    );
  };

  const suspendInactiveTextifyFields = (form, activeFields) => {
    const active = new Set(activeFields);
    const suspended = getTextifyFields(form, false).filter(
      (field) => !active.has(field) && field.form === form
    );

    suspended.forEach((field) => {
      field.disabled = true;
    });

    return () => {
      suspended.forEach((field) => {
        field.disabled = false;
      });
    };
  };

  const textifyFieldsAreValid = (fields) => {
    for (const field of fields) {
      if (!field.reportValidity()) {
        field.focus();
        return false;
      }
    }
    return true;
  };

  const copyTextifyValues = (formData, fields) => {
    fields.forEach((field) => {
      if (field instanceof HTMLInputElement && field.type === 'file') return;
      if (
        field instanceof HTMLInputElement &&
        (field.type === 'checkbox' || field.type === 'radio') &&
        !field.checked
      ) {
        return;
      }

      const propertyName =
        field.getAttribute('data-name') ||
        field.getAttribute('data-property') ||
        field.name;
      if (!propertyName?.startsWith('properties[')) return;

      formData.delete(propertyName);
      if (field instanceof HTMLSelectElement && field.multiple) {
        Array.from(field.selectedOptions).forEach((option) => {
          if (option.value) formData.append(propertyName, option.value);
        });
      } else if (field.value) {
        formData.append(propertyName, field.value);
      }
    });
  };

  window.addEventListener(
    'click',
    (event) => {
      const target = event.target;
      if (!(target instanceof Element)) return;

      const textifyButton = target.closest('.textboxAddToCartBtn');
      const standardButton = enableStandardProductForm
        ? target.closest('product-form form[action*="/cart/add"] [type="submit"]')
        : null;
      const addButton = textifyButton || standardButton;
      if (!addButton) return;

      const form = addButton.closest('form[action*="/cart/add"]');
      if (!form) return;

      const textifyFields = textifyButton ? getTextifyFields(form) : [];
      if (textifyButton && !standardButton && textifyFields.length === 0) {
        return;
      }

      event.preventDefault();
      event.stopImmediatePropagation();

      if (addButton.getAttribute('aria-disabled') === 'true') return;

      const restoreInactiveFields = suspendInactiveTextifyFields(
        form,
        textifyFields
      );
      const isValid =
        textifyFieldsAreValid(textifyFields) && form.reportValidity();
      if (!isValid) {
        restoreInactiveFields();
        return;
      }

      const cart =
        document.querySelector('cart-notification') ||
        document.querySelector('cart-drawer');
      const spinner = form.querySelector('.loading-overlay__spinner');
      const errorWrapper = form.querySelector(
        '.product-form__error-message-wrapper'
      );
      const errorMessage = errorWrapper?.querySelector(
        '.product-form__error-message'
      );

      errorWrapper?.setAttribute('hidden', '');
      addButton.setAttribute('aria-disabled', 'true');
      addButton.classList.add('loading');
      spinner?.classList.remove('hidden');

      const formData = new FormData(form);
      copyTextifyValues(formData, textifyFields);
      restoreInactiveFields();

      if (cart?.getSectionsToRender) {
        formData.append(
          'sections',
          cart.getSectionsToRender().map((section) => section.id)
        );
        formData.append('sections_url', window.location.pathname);
        cart.setActiveElement?.(document.activeElement);
      }

      fetch(window.routes?.cart_add_url || '/cart/add.js', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: formData,
      })
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            console.warn(
              'Strong N Free dropdown cart request was rejected:',
              response.description
            );
            if (errorWrapper && errorMessage) {
              errorMessage.textContent = response.description;
              errorWrapper.removeAttribute('hidden');
            }
            return;
          }

          if (cart?.renderContents) {
            cart.renderContents(response);
          } else {
            window.location.assign(window.routes?.cart_url || '/cart');
          }
        })
        .catch((error) => {
          console.error('Strong N Free dropdown cart error:', error);
          if (errorWrapper && errorMessage) {
            errorMessage.textContent =
              'There was an error adding this item to the cart. Please try again.';
            errorWrapper.removeAttribute('hidden');
          }
        })
        .finally(() => {
          addButton.classList.remove('loading');
          addButton.removeAttribute('aria-disabled');
          spinner?.classList.add('hidden');
        });
    },
    true
  );
})();
